'use strict';

exports.__esModule = true;
// Generated by CoffeeScript 1.12.6
var emptySubscription;

exports.default = emptySubscription = Object.defineProperty({
  unsubscribe: function () {}
}, 'closed', {
  configurable: true,
  enumerable: true,
  get: function () {
    return true;
  }
});